import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectOptionViewModel from '@/ViewModels/Controls/MultiSelectOptionViewModel';

export default class MultiSelectViewModel extends ControlViewModel {

    /**
     * Beinhaltet die selektierten Werte
     */
    public values: KnockoutComputed<any>;

    /**
     * Beinhaltet die selektierten Werte
     */
    public options: KnockoutObservable<Array<MultiSelectOptionViewModel>>;

    /**
     * Das ViewModel für den MultiSelect
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.values = this.definePureComputed({
            read: () => {
                let result = [];
                let options = this.options();

                for (let i = 0; i < options.length; i++) {
                    if (options[i].isSelected() === true) {
                        result.push(options[i].value());
                    }
                }
                return result;
            },
            write: (values) => {
                let options = this.options();

                for (let i = 0; i < options.length; i++) {
                    let value = options[i].value();
                    let isSelected = values.indexOf(value) > -1;

                    options[i].isSelected(isSelected);
                }
            }
        });
        this.options = this.observableOrDefault(params.options, []);
    }
}

ComponentManager.setViewModel('MultiSelectViewModel', MultiSelectViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');